import Label from 'umg-ember-backend/components/record-explorer/for/label';

<template><Label @records={{@model}} @recordType='label' /></template>
